import type {UploadForestMass} from '@/domain/entities/Op';
import type {OpRepository} from '@/domain/interfaces/OpRepository';

export class OpUploadForestMassUseCase {
  constructor(private readonly repository: OpRepository) {}
  execute = async (domain: UploadForestMass, file: File) => {
    await this.repository.uploadForestMasses(domain, file);
  };
}
